import { render, staticRenderFns } from "./BasePhone.vue?vue&type=template&id=2e9b3f1c"
import script from "./BasePhone.vue?vue&type=script&lang=ts"
export * from "./BasePhone.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports